import { observer } from 'mobx-react'
import { createElement } from 'react';
import { IconComponent, MUICoreIcon } from '../../../stores/models/Icon';

interface DynamicIconProps<IconAttributes extends React.Attributes> {
    icon: IconComponent | string;
    attributes?: IconAttributes;
}

const DynamicIcon = observer(<IconAttributes extends object>(props: DynamicIconProps<IconAttributes>) => {

    /********* Render *********/

    return createElement(props.icon as MUICoreIcon, props.attributes);
});

export default DynamicIcon;